import {
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_BOTTOM,
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_LEFT,
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_RIGHT,
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_TOP,
  ENTITY_LIST_DRAG_HANDLE_PADDING_BOTTOM,
  ENTITY_LIST_DRAG_HANDLE_PADDING_LEFT,
  ENTITY_LIST_DRAG_HANDLE_PADDING_RIGHT,
  ENTITY_LIST_DRAG_HANDLE_PADDING_TOP,
  ENTITY_LIST_ICON_LARGE_SIZE,
  ENTITY_LIST_MEDIUM_DOT_PADDING_BOTTOM,
  ENTITY_LIST_MEDIUM_DOT_PADDING_LEFT,
  ENTITY_LIST_MEDIUM_DOT_PADDING_RIGHT,
  ENTITY_LIST_MEDIUM_DOT_PADDING_TOP,
  ENTITY_LIST_MEDIUM_DOT_SIZE,
  IDENTIFIER_LINE_HEIGHT,
  IDENTIFIER_LIST_DOWN_ARROW_MARGIN_X,
  IDENTIFIER_LIST_DOWN_ARROW_PADDING_TOP,
  IDENTIFIER_LIST_DOWN_ARROW_SIZE,
  IDENTIFIER_SLUG_FONT_SIZE,
  ITEM_CARD_ARROW_PADDING_BOTTOM,
  ITEM_CARD_ARROW_PADDING_LEFT,
  ITEM_CARD_ARROW_PADDING_RIGHT,
  ITEM_CARD_ARROW_PADDING_TOP,
  ITEM_CARD_ARROW_SIZE,
  ITEM_CARD_AVATAR_REMAINER_PADDING_X,
  ITEM_CARD_BLOCK_ICON_SIZE,
  ITEM_CARD_DRAG_HANDLE_PADDING_BOTTOM,
  ITEM_CARD_DRAG_HANDLE_PADDING_LEFT,
  ITEM_CARD_DRAG_HANDLE_PADDING_RIGHT,
  ITEM_CARD_DRAG_HANDLE_PADDING_TOP,
  ITEM_CARD_EVENT_COL_PADDING_LEFT,
  ITEM_CARD_EVENT_ROW_EDIT_MODE_PADDING_X,
  ITEM_CARD_EVENT_ROW_PADDING_LEFT,
  ITEM_CARD_EVENT_ROW_PADDING_RIGHT,
  ITEM_CARD_FORM_RADIO_PADDING_LEFT,
  ITEM_CARD_FORM_RADIO_PADDING_RIGHT,
  ITEM_CARD_IDENTIFIER_MARGIN_X,
  ITEM_CARD_IDENTIFIER_MARGIN_Y,
  ITEM_CARD_IDENTIFIER_ROW_MARGIN_Y,
  ITEM_CARD_IMAGE_MARGIN_TOP,
  ITEM_CARD_INDENT_PADDING,
  ITEM_CARD_INDENT_PADDING_WIDTH_CHILDREN,
  ITEM_CARD_INLINE_AVATAR_MARGIN_X,
  ITEM_CARD_INLINE_AVATAR_MARGIN_Y,
  ITEM_CARD_INLINE_AVATAR_SIZE,
  ITEM_CARD_NARRATIVE_MARGIN_TOP,
  SPLIT_BUTTON_LABEL_PADDING_Y,
  SPLIT_BUTTON_LINE_HEIGHT,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_BOTTOM,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_LEFT,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_RIGHT,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_TOP,
  TREE_VIEW_COLLAPSE_ARROW_SIZE,
  TREE_VIEW_INDENT,
  TREE_VIEW_ITEM_BASE_PADDING_LEFT,
  TREE_VIEW_LIST_ITEM_MIDDLE_ELEMENT_MARGIN_LEFT
} from "../..";
import app from "../app";

const WORKVIEW_HEADER_HEIGHT = 28;

const BASE_LINE_HEIGHT = app.LINE_HEIGHT;

const TOOLBAR_ICON_SIZE = 22;
const TOOLBAR_ICON_MARGIN_X = 5;
const NARRATIVE_CARD_MIN_INNER_HEIGHT = 80;
const NARRATIVE_CARD_Y_PADDING = 11;
const NARRATIVE_GROUP_HEADING_HEIGHT = 35;

export default {
  // The base font size used for all calculations
  BASE_FONT_SIZE: app.FONT_SIZE,
  BASE_LINE_HEIGHT,

  // The global font size for non-workview UI
  GLOBAL_FONT_SIZE: 13,

  // Interface
  IDENTIFIER: {
    FONT_SIZE: IDENTIFIER_SLUG_FONT_SIZE,
    LINE_HEIGHT: IDENTIFIER_LINE_HEIGHT,
    PADDING: {
      TOP: 4,
      RIGHT: 4,
      BOTTOM: 3,
      LEFT: 4
    }
  },

  // Main App Dimensions
  APP_TITLE_BAR_HEIGHT: 38,
  TOOLBAR_HEIGHT: 38,
  TOOLBAR_ICON_HEIGHT: TOOLBAR_ICON_SIZE,
  TOOLBAR_ICON_MARGIN_Y: 3,
  TOOLBAR_ICON_MARGIN_X: TOOLBAR_ICON_MARGIN_X,
  TOOLBAR_ICON_SIZE,
  TOOLBAR_ICON_PADDED_WIDTH: TOOLBAR_ICON_SIZE + 2 * TOOLBAR_ICON_MARGIN_X,
  TOOLBAR_GROUP_ICON_SIZE: 20,
  TOOLBAR_PADDING_X: 4,
  TOOLBAR_TEXT_PADDING_X: 10,
  TOOLBAR_GROUP_MIN_WIDTH: 62,
  TOOLBAR_FONT_SIZE: 13,
  NOTIFICATION_BAR_HEIGHT: 50,
  FOOTER_HEIGHT: 35,
  SIDEBAR_WIDTH: 46,
  WORKVIEW_HEADER_HEIGHT,

  // Size of the panels
  MIN_LEFT_PANEL_WIDTH: 200,
  DEFAULT_LEFT_PANEL_WIDTH: 250,
  MAX_LEFT_PANEL_WIDTH: 300,
  COLLAPSED_LEFT_PANEL_WIDTH: 0,
  MIN_RIGHT_PANEL_WIDTH: 250,
  DEFAULT_RIGHT_PANEL_WIDTH: 300,
  MAX_RIGHT_PANEL_WIDTH: 450,
  COLLAPSED_RIGHT_PANEL_WIDTH: 10,

  // Size of the workviews
  COLLAPSE_WORKVIEW_HEIGHT: WORKVIEW_HEADER_HEIGHT,
  MIN_WORKVIEW_SIZE: 200,
  MIN_WORKVIEW_HEIGHT: 150,

  // Size of the modal
  MODAL_TOP: 48, // TOOLBAR_HEIGHT + 10
  MODAL_BOTTOM: 45, // FOOTER_HEIGHT + 10
  MODAL_MAX_HEIGHT: 958,
  MODAL_MASTER_WIDTH: 224,
  MODAL_MASTER_DETAIL_TOP_MARGIN: 15,
  MODAL_X_PADDING: 15,
  MODAL_Y_PADDING: 18,
  MODAL_Y_BORDER_WIDTH: 1,
  MODAL_HEADING_HEIGHT: 43,
  MODAL_FOOTER_HEIGHT: 41,
  MODAL_FOOTER_PADDING_Y: 5,
  MODAL_TAB_BAR_HEIGHT: 70,
  MODAL_TAB_BAR_MARGIN: 5,

  MODAL_SETTINGS_LIST_OPTIONS_WIDTH: 307,

  PRINT_PREVIEW_NAVIGATION_HEIGHT: 32,

  // Scrollbars
  SCROLLBAR_TRACK_SIZE: 14,

  // Item Cards
  MAX_ITEM_TEXT_WIDTH: 285,

  // Item card list
  ITEM_CARD_EVENT_DOT_MARGIN_X: 5,
  ITEM_CARD_EVENT_DOT_SIZE: 10,
  ITEM_CARD_EVENT_ROW_PADDING_LEFT: ITEM_CARD_EVENT_ROW_PADDING_LEFT,
  ITEM_CARD_EVENT_ROW_PADDING_RIGHT: ITEM_CARD_EVENT_ROW_PADDING_RIGHT,
  ITEM_CARD_EVENT_ROW_EDIT_MODE_PADDING_X: ITEM_CARD_EVENT_ROW_EDIT_MODE_PADDING_X, //px
  ITEM_CARD_ARROW_PADDING_TOP: ITEM_CARD_ARROW_PADDING_TOP,
  ITEM_CARD_ARROW_PADDING_RIGHT: ITEM_CARD_ARROW_PADDING_RIGHT,
  ITEM_CARD_ARROW_PADDING_BOTTOM: ITEM_CARD_ARROW_PADDING_BOTTOM,
  ITEM_CARD_ARROW_PADDING_LEFT: ITEM_CARD_ARROW_PADDING_LEFT,
  ITEM_CARD_ARROW_SIZE: ITEM_CARD_ARROW_SIZE,
  ITEM_CARD_EVENT_COL_PADDING_LEFT: ITEM_CARD_EVENT_COL_PADDING_LEFT,
  ITEM_CARD_INDENT_PADDING: ITEM_CARD_INDENT_PADDING,
  ITEM_CARD_INDENT_PADDING_WIDTH_CHILDREN: ITEM_CARD_INDENT_PADDING_WIDTH_CHILDREN,
  ITEM_CARD_EVENT_DRAG_HANDLE_SIZE: 30,
  ITEM_CARD_DRAG_HANDLE_PADDING_LEFT: ITEM_CARD_DRAG_HANDLE_PADDING_LEFT,
  ITEM_CARD_DRAG_HANDLE_PADDING_RIGHT: ITEM_CARD_DRAG_HANDLE_PADDING_RIGHT,
  ITEM_CARD_DRAG_HANDLE_PADDING_TOP: ITEM_CARD_DRAG_HANDLE_PADDING_TOP,
  ITEM_CARD_DRAG_HANDLE_PADDING_BOTTOM: ITEM_CARD_DRAG_HANDLE_PADDING_BOTTOM,
  ITEM_CARD_FORM_RADIO_PADDING_LEFT: ITEM_CARD_FORM_RADIO_PADDING_LEFT,
  ITEM_CARD_FORM_RADIO_PADDING_RIGHT: ITEM_CARD_FORM_RADIO_PADDING_RIGHT,

  ITEM_CARD_EVENT_RADIO_SIZE: 17,

  ITEM_CARD_IDENTIFIER_ROW_MARGIN_Y: ITEM_CARD_IDENTIFIER_ROW_MARGIN_Y,
  ITEM_CARD_IDENTIFIER_MARGIN_X: ITEM_CARD_IDENTIFIER_MARGIN_X,
  ITEM_CARD_IDENTIFIER_MARGIN_Y: ITEM_CARD_IDENTIFIER_MARGIN_Y,

  ITEM_CARD_AVATAR: {
    WIDTH: ITEM_CARD_INLINE_AVATAR_SIZE,
    HEIGHT: ITEM_CARD_INLINE_AVATAR_SIZE,
    LINE_HEIGHT: ITEM_CARD_INLINE_AVATAR_SIZE,
    MARGIN_RIGHT: ITEM_CARD_INLINE_AVATAR_MARGIN_X,
    MARGIN_BOTTOM: ITEM_CARD_INLINE_AVATAR_MARGIN_Y
  },

  ITEM_CARD_AVATAR_REMAINER: {
    FONT_SIZE: 11,
    LINE_HEIGHT: 22,
    PADDING_LEFT: ITEM_CARD_AVATAR_REMAINER_PADDING_X
  },

  ITEM_CARD_BLOCK_ICON_SIZE: ITEM_CARD_BLOCK_ICON_SIZE,

  ITEM_CARD_NARRATIVE_LABEL_MARGIN_TOP: ITEM_CARD_NARRATIVE_MARGIN_TOP,

  ITEM_CARD_IMAGE_MARGIN_TOP: ITEM_CARD_IMAGE_MARGIN_TOP,

  // Narrative View

  NARRATIVE_CARD_NUM_BACKGROUND_COLOURS: 3,
  NARRATIVE_CARD_CHILD_X_PADDING: 15,
  NARRATIVE_CARD_CHILD_Y_PADDING: 10,
  NARRATIVE_CARD_CHILD_X_MARGIN: 20,
  NARRATIVE_CARD_CHILD_Y_MARGIN: 10,
  NARRATIVE_CARD_CHILDREN_MARGIN_X: 20,

  NARRATIVE_CARD_LINE_DROP_WIDTH: 4,
  NARRATIVE_CARD_DRAG_DROP_BORDER_ALLOWANCE: 20,
  NARRATIVE_CARD_FILTER_DROP_ADJUSTMENT: 5,

  NARRATIVE_CARD_WIDTH: 361,
  NARRATIVE_CARD_MIN_INNER_HEIGHT: NARRATIVE_CARD_MIN_INNER_HEIGHT,
  NARRATIVE_CARD_MIN_INNER_HEIGHT_WHEN_EXCLUDED: 40,
  NARRATIVE_CARD_Y_PADDING: NARRATIVE_CARD_Y_PADDING,
  NARRATIVE_GROUP_X_PADDING: 20,
  NARRATIVE_GROUP_WIDTH: 362,
  NARRATIVE_GROUP_SPACING: 0,
  NARRATIVE_GROUP_TOP_MARGIN: 0,
  NARRATIVE_GROUP_HEADING_HEIGHT: NARRATIVE_GROUP_HEADING_HEIGHT,
  NARRATIVE_GROUP_DROP_TARGET_HEIGHT: 110,
  NARRATIVE_GROUP_MINIMUM_HEIGHT:
    NARRATIVE_GROUP_HEADING_HEIGHT + NARRATIVE_CARD_MIN_INNER_HEIGHT + 2 * NARRATIVE_CARD_Y_PADDING,
  NARRATIVE_COLUMN_WIDTH: 383,
  NARRATIVE_COLUMN_X_PADDING: 10,
  NARRATIVE_COLUMN_HEADING_HEIGHT: 24,
  NARRATIVE_COLUMN_HEADING_HEIGHT_WITH_MARGIN: 34,
  NARRATIVE_ADD_NODE_BUTTON_HEIGHT: 40,

  // Inspector
  INSPECTOR_TEXT_AREA_PADDING: 5,

  DROPDOWN_ICON_SIZE: 16,

  // Identifiers List
  IDENTIFIER_LIST_DOWN_ARROW_SIZE: IDENTIFIER_LIST_DOWN_ARROW_SIZE,
  IDENTIFIER_LIST_DOWN_ARROW_MARGIN_X: IDENTIFIER_LIST_DOWN_ARROW_MARGIN_X,
  IDENTIFIER_LIST_DOWN_ARROW_PADDING_TOP: IDENTIFIER_LIST_DOWN_ARROW_PADDING_TOP,

  // Form (SplitButton)
  SPLIT_BUTTON_LINE_HEIGHT: SPLIT_BUTTON_LINE_HEIGHT,
  SPLIT_BUTTON_LABEL_PADDING_Y: SPLIT_BUTTON_LABEL_PADDING_Y,

  // Tree
  TREE_VIEW_ITEM_BASE_PADDING_LEFT: TREE_VIEW_ITEM_BASE_PADDING_LEFT,
  TREE_VIEW_COLLAPSE_ARROW_SIZE: TREE_VIEW_COLLAPSE_ARROW_SIZE,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_TOP: TREE_VIEW_COLLAPSE_ARROW_PADDING_TOP,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_RIGHT: TREE_VIEW_COLLAPSE_ARROW_PADDING_RIGHT,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_BOTTOM: TREE_VIEW_COLLAPSE_ARROW_PADDING_BOTTOM,
  TREE_VIEW_COLLAPSE_ARROW_PADDING_LEFT: TREE_VIEW_COLLAPSE_ARROW_PADDING_LEFT,
  TREE_VIEW_LIST_ITEM_MIDDLE_ELEMENT_MARGIN_LEFT: TREE_VIEW_LIST_ITEM_MIDDLE_ELEMENT_MARGIN_LEFT,
  TREE_VIEW_INDENT: TREE_VIEW_INDENT,

  // Entity
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_TOP: ENTITY_LIST_COLLAPSE_ARROW_PADDING_TOP,
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_RIGHT: ENTITY_LIST_COLLAPSE_ARROW_PADDING_RIGHT,
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_BOTTOM: ENTITY_LIST_COLLAPSE_ARROW_PADDING_BOTTOM,
  ENTITY_LIST_COLLAPSE_ARROW_PADDING_LEFT: ENTITY_LIST_COLLAPSE_ARROW_PADDING_LEFT,
  ENTITY_LIST_ICON_LARGE_SIZE: ENTITY_LIST_ICON_LARGE_SIZE,
  ENTITY_LIST_DRAG_HANDLE_PADDING_TOP: ENTITY_LIST_DRAG_HANDLE_PADDING_TOP,
  ENTITY_LIST_DRAG_HANDLE_PADDING_BOTTOM: ENTITY_LIST_DRAG_HANDLE_PADDING_BOTTOM,
  ENTITY_LIST_DRAG_HANDLE_PADDING_LEFT: ENTITY_LIST_DRAG_HANDLE_PADDING_LEFT,
  ENTITY_LIST_DRAG_HANDLE_PADDING_RIGHT: ENTITY_LIST_DRAG_HANDLE_PADDING_RIGHT,
  ENTITY_LIST_MEDIUM_DOT_SIZE: ENTITY_LIST_MEDIUM_DOT_SIZE,
  ENTITY_LIST_MEDIUM_DOT_PADDING_TOP: ENTITY_LIST_MEDIUM_DOT_PADDING_TOP,
  ENTITY_LIST_MEDIUM_DOT_PADDING_RIGHT: ENTITY_LIST_MEDIUM_DOT_PADDING_RIGHT,
  ENTITY_LIST_MEDIUM_DOT_PADDING_BOTTOM: ENTITY_LIST_MEDIUM_DOT_PADDING_BOTTOM,
  ENTITY_LIST_MEDIUM_DOT_PADDING_LEFT: ENTITY_LIST_MEDIUM_DOT_PADDING_LEFT
};
